/* Seoul Rituals — aparición suave al entrar en pantalla.
   Sin dependencias. Se desactiva si el usuario pide menos movimiento.
   Si IntersectionObserver no existe, todo queda visible. */
(function () {
  var SEL = '.sr-reveal';

  function showAll() {
    document.querySelectorAll(SEL).forEach(function (el) { el.classList.add('is-in'); });
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    showAll();
    return;
  }

  if (!('IntersectionObserver' in window)) {
    showAll();
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  function observe(root) {
    (root || document).querySelectorAll(SEL + ':not(.is-in)').forEach(function (el) { io.observe(el); });
  }

  observe(document);

  /* El editor de temas y la re-renderizacion de secciones inyectan HTML nuevo. */
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  document.addEventListener('shopify:block:select', function (e) { e.target.classList.add('is-in'); });

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; observe(document); });
  }).observe(document.body, { childList: true, subtree: true });
})();
